export default __webpack_public_path__ + "static/media/feng.32182226.png";